<div class="min-h-full flex flex-col">
  <mat-sidenav-container class="example-container flex-1 !flex">
    <mat-sidenav [mode]="mode" [opened]="isShowSlideBar" style="width: 260px; box-shadow: 2px 0px 4px #e4e6ee !important;">
      <app-slidebar />
    </mat-sidenav>
    <mat-sidenav-content class="example-sidenav-content flex-1 xl:px-12 lg:px-11 sm:px-5 px-3 sm:py-5 py-3 pt-[40px]">
  <app-toolbar [changeShowSlidebar]="changeShowSlidebar" style="z-index: 99;"/>      
  <button mat-icon-button 
  class="absolute -left-[45px] rounded-[5px] top-[15px] w-[55px] h-[55px] text-[#ebf6ff] flex items-center justify-end [transition:0.5s_ease-out] bg-[#1bb3943d] border-[0] p-[.5rem] hover:bg-[#1BB394] hover:-left-[20px]"
   aria-label="Example icon-button with menu icon" (click)="changeShowSlidebar()">
    <mat-icon [title]="isShowSlideBar ? 'Collapse Menu' : 'Expand Menu'"  class="material-symbols-outlined text-[xx-large] flex items-center justify-center" style="display: flex;"> menu </mat-icon>
  </button>
      <ng-content class="mt-[6vh]"></ng-content>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>